import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Mobile "back swipe" — swipe right starting from the left edge of the screen
// navigates back home. Edge-only start avoids interfering with horizontally
// scrollable content (e.g. the comparison table).
export default function SwipeBackHome() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let startX = 0;
    let startY = 0;
    let startT = 0;
    let tracking = false;

    const EDGE = 40; // px from left edge to start the gesture
    const DIST = 70; // min horizontal distance
    const MAX_OFF = 60; // max vertical drift
    const MAX_TIME = 700; // ms

    const isMobile = () => window.innerWidth < 768;

    const onStart = (e) => {
      if (!isMobile()) return;
      const t = e.touches[0];
      if (t.clientX <= EDGE) {
        tracking = true;
        startX = t.clientX;
        startY = t.clientY;
        startT = Date.now();
      } else {
        tracking = false;
      }
    };

    const onEnd = (e) => {
      if (!tracking) return;
      tracking = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const dt = Date.now() - startT;
      if (dx >= DIST && Math.abs(dy) <= MAX_OFF && dt <= MAX_TIME) {
        if (window.location.pathname !== "/") navigate("/");
      }
    };

    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchend", onEnd);
    };
  }, [navigate, location.pathname]);

  return null;
}
